var map = {
	"./avatar_1.png": 19974,
	"./avatar_10.png": 83700,
	"./avatar_11.png": 16733,
	"./avatar_12.png": 19174,
	"./avatar_13.png": 58191,
	"./avatar_14.png": 62320,
	"./avatar_15.png": 68569,
	"./avatar_16.png": 12482,
	"./avatar_17.png": 33611,
	"./avatar_18.png": 24124,
	"./avatar_19.png": 7013,
	"./avatar_2.png": 87389,
	"./avatar_20.png": 99913,
	"./avatar_3.png": 66260,
	"./avatar_4.png": 58251,
	"./avatar_5.png": 94594,
	"./avatar_6.png": 8601,
	"./avatar_7.png": 92848,
	"./avatar_8.png": 66679,
	"./avatar_9.png": 76686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40449;